// This file is AUTOGENERATED, do not edit it manually!!!

export const errors = {
    attachment_file_exists: 'Dosya \'{0}\' zaten diskte depolandı',
    dates_empty: 'Bu raporu çalıştırmak için \'kimden\' ve \'kime\' tarihleri belirtmelisiniz',
    errorRemoveProjectManager: 'Projesi üyesi \'{0}\' kaldırılamaz',
    invalid_permission_to_delete: 'Bu nesneyi silmek için izni yok',
    invalid_permission_to_insert: 'Bu nesne eklemek için izni yok',
    invalid_permission_to_update: 'Bu nesnenin güncelleştirilmesi için izni yok',
    invalid_uploaded_avatar: 'Geçersiz resim. Kabul edilebilir grafik biçimleri JPG, GIF ve PNG. ve en büyük dosya boyutu {0} Mb.',
    invalid_uploaded_passwordwords: 'TXT dosyası geçersiz. *.Txt kabul edilebilir bir dosya biçimidir.',
    no_file_selected: 'Dosya yok veya boş bir dosya seçtiniz.',
    noProjectMember: 'User {0} has not been added to assignees because he/she take no part in the project \"{1}\" and you does not have permissions to manage project members in this project.',
    parent_task_not_found: 'Projede ana etkinlik \'{0}\' bulunamadı.',
    priority_duplicate_order_error: 'Öncelikli olarak belirtilen isim zaten mevcut.',
    project_import_invalid_format: 'Dosya geçerli bir. Mpp veya. Xml dosyası olmalıdır.',
    project_import_invalid_mpp: 'Dosyanın geçerli bir. Mpp dosyası olması gerekir.',
    project_import_invalid_mpx: 'Dosyanın geçerli bir. Mpx dosyası olması gerekir.',
    project_import_invalid_structure: 'Dosyanın yanlış yapısı var.',
    project_no_customer_for_customer_billing: 'Proje faturalama türü  müşteri oranı için ayarlanmışsa, bir müşteri belirtmeniz gerekir.',
    publicholidays_duplicate_name_error: 'Resmi tatil olarak belirtilen tarihli zaten bulunmaktadır.',
    report_data_source_required: 'Raporu kaydetmek için önce  bir veri kaynağı seçilmelidir. Birini seçin ve raporu kaydetmek için \' Seç\'i  tıklayın.',
    tasks_import_empty_name: 'Satır {0}: aktivite adı boş bir dize olamaz.',
};
